import { Scroll } from '@/lib/scroll'
import { onPageIn, onMount, onDestroy } from '@/modules/_'
import gsap from 'gsap'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let trigger: HTMLElement | null = null
  let closeButton: HTMLElement | null = null
  let video: HTMLVideoElement | null = null
  let videoWrap: HTMLElement | null = null
  let isAnimating = false
  let isFullscreen = false

  const openModal = (videoUrl: string) => {
    if (isAnimating) return
    isAnimating = true
    isFullscreen = true
    Scroll.stop()

    // Set video source
    if (video) {
      video.src = videoUrl
    }

    // Set initial states
    gsap.set(element, {
      display: 'flex',
      // clipPath: 'inset(0% 0% 100% 0%)',
      opacity: 0,
    })

    gsap.set([videoWrap, closeButton], {
      opacity: 0,
    })

    // Stabilize video wrap to prevent jumpiness
    if (videoWrap) {
      gsap.set(videoWrap, {
        willChange: 'opacity',
        force3D: true,
      })
    }

    // Create timeline
    const tl = gsap.timeline({
      onComplete: () => {
        isAnimating = false
        if (video) {
          video.play()
          video.controls = true
        }
      },
    })

    tl.to(element, {
      // clipPath: 'inset(0% 0% 0% 0%)',
      opacity: 1,
      duration: 1.2,
      ease: 'power3.out',
    })
    tl.to(
      [videoWrap, closeButton],
      {
        opacity: 1,
        duration: 1,
        ease: 'power2.inOut',
        clearProps: 'willChange',
      },
      '<'
    )
  }

  const closeModal = () => {
    if (isAnimating) return
    isAnimating = true
    isFullscreen = false
    Scroll.start()

    // Pause video
    if (video) {
      video.pause()
    }

    // Create reverse timeline
    const tl = gsap.timeline({
      onComplete: () => {
        gsap.set(element, { display: 'none' })
        if (video) video.src = ''
        isAnimating = false
      },
    })

    // Fade out video and button first
    tl.to([videoWrap, closeButton, element], {
      opacity: 0,
      duration: 0.4,
      ease: 'power2.out',
    })

    // // Then clip-path the modal away (bottom to top)
    // tl.to(
    //   element,
    //   {
    //     // clipPath: 'inset(0% 0% 100% 0%)',
    //     opacity: 0,
    //     duration: 0.6,
    //     ease: 'expo.out',
    //   },
    //   0.25
    // ) // Start 0.25s after fade begins
  }

  onMount(() => {
    // Find elements
    trigger = document.querySelector('[data-lightbox="trigger"]')
    closeButton = element.querySelector('[menu="trigger-close"]')
    video = element.querySelector('video')
    videoWrap = element.querySelector('.lightbox_video_wrap')

    // Set initial state
    gsap.set(element, { display: 'none' })

    // Add event listeners
    if (trigger) {
      trigger.addEventListener('click', () => {
        const videoUrl = trigger?.getAttribute('data-video-url')
        if (videoUrl) {
          openModal(videoUrl)
        }
      })
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal)
    }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isFullscreen) {
        closeModal()
      }
    })

    // Close on backdrop click (optional)
    element.addEventListener('click', (e) => {
      if (e.target === element) {
        closeModal()
      }
    })
  })

  onDestroy(() => {
    // Cleanup if needed
    if (video) {
      video.pause()
      video.src = ''
    }
  })
}
